<h1 mat-dialog-title>Registrar tiempo</h1>

<mat-dialog-content [formGroup]="form">
  @if (show_icloud_private_relay_warning()) {
    <app-icloud-private-relay-warning-banner context="working-time" />
  }

  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-5">
        <div class="row">
          <div class="col-12">
            <mat-label>Fecha</mat-label>
            <mat-form-field appearance="outline" class="nobottom">
              <input [max]="maxDate" matInput [matDatepicker]="picker" [formControl]="dateControl" />
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-lg-6">
            <mat-label>Tiempo</mat-label>
            <mat-form-field appearance="outline" class="nobottom">
              <input type="text" matInput [formControl]="timeControl" placeholder="3h 30m" />
            </mat-form-field>
          </div>
          <div class="col-12 col-lg-6">
            <mat-label>Inicio</mat-label>
            <mat-form-field appearance="outline" class="nobottom">
              <input type="time" matInput [formControl]="startTimeControl" />
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <mat-label>Categoria</mat-label>
            <mat-form-field appearance="outline" class="nobottom">
              <mat-select
                [formControlName]="is_company_product_category ? null : 'working_time_category_id'"
                (selectionChange)="onCategoryChange($event, 0)"
              >
                @for (wtc of working_time_categories; track wtc) {
                  <mat-option [value]="wtc.id">
                    {{ wtc.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        @if (showReviewTargetSelector()) {
          <div class="row">
            <div class="col-12">
              <mat-label>¿Qué estás revisando?</mat-label>
              <mat-form-field appearance="outline" class="nobottom">
                <mat-select formControlName="relatable_id">
                  @for (budget of reviewTargetBudgets(); track budget.id) {
                    <mat-option [value]="budget.id">
                      {{ budget.review_target_label }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        }
        @if (is_company_product_category) {
          <div class="row">
            <div class="col-12">
              <mat-label>Producto</mat-label>
              <mat-form-field appearance="outline" class="nobottom">
                <input
                  type="text"
                  matInput
                  [formControl]="companyProductControl"
                  [matAutocomplete]="companyProductAuto"
                  placeholder="Buscar productos..."
                />
                <mat-autocomplete
                  #companyProductAuto="matAutocomplete"
                  (optionSelected)="selectCompanyProduct($event.option.value)"
                  [displayWith]="displayFnCompanyProduct"
                >
                  @for (company_product of filtered_company_products; track company_product.id) {
                    <mat-option [value]="company_product">{{ company_product.title }} </mat-option>
                  }
                </mat-autocomplete>
                @if (form.value['company_product_id'] !== '') {
                  <button matSuffix mat-icon-button aria-label="Clear" (click)="resetCompanyProduct()">
                    <mat-icon>close</mat-icon>
                  </button>
                }
              </mat-form-field>
            </div>
          </div>
        }

        @for (subcategory_available_level of available_working_time_categories; track subcategory_available_level; let i = $index) {
          <div class="row">
            <div class="col-12">
              <mat-label>{{ 'Sub. de ' + selected_working_time_categories[i].name }}</mat-label>
              <mat-form-field appearance="outline" class="nobottom">
                <mat-select formControlName="" (selectionChange)="onCategoryChange($event, i + 1)">
                  @for (category of subcategory_available_level; track category) {
                    <mat-option [value]="category.id">
                      {{ category.name }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        }

        @if (is_learning_resource_category) {
          <div class="row">
            <div class="col-12">
              <mat-label>Formación</mat-label>
              <mat-form-field appearance="outline" class="nobottom">
                <mat-select formControlName="relatable_id" (selectionChange)="onLearningResourceSelected($event.value)">
                  @for (enrollment of active_learning_resource_enrollments; track enrollment.id) {
                    @if (enrollment.learning_resource; as learning_resource) {
                      <mat-option [value]="enrollment.learning_resource_id">
                        {{ learning_resource.name }}
                      </mat-option>
                    }
                  }
                </mat-select>
              </mat-form-field>
              @if (active_learning_resource_enrollments.length === 0) {
                <p class="formation-warning">
                  No tienes una formación activa. Activa una formación en
                  <a routerLink="/employees/performance/upskilling/catalog">Upskilling — Catálogo</a>
                  o pide a RRHH que te matricule antes de registrar tiempo de curso.
                </p>
              }
            </div>
          </div>
        }

        @if (is_company_product_phase_category) {
          <div class="row">
            <div class="col-12">
              <mat-label>Fase</mat-label>
              <mat-form-field appearance="outline" class="nobottom">
                <input
                  type="text"
                  matInput
                  [formControl]="companyProductPhaseControl"
                  [matAutocomplete]="companyProductPhaseAuto"
                  placeholder="Buscar fases..."
                  (focus)="onCompanyProductPhaseInputFocus()"
                  #companyProductPhaseAutocompleteTrigger="matAutocompleteTrigger"
                />
                <mat-autocomplete
                  #companyProductPhaseAuto="matAutocomplete"
                  (optionSelected)="selectCompanyProductPhase($event.option.value)"
                  [displayWith]="displayFnCompanyProductPhase"
                >
                  @for (phase of filtered_company_product_phases; track phase.id) {
                    <mat-option [value]="phase">{{ phase.company_product_phase_type.name }} </mat-option>
                  }
                </mat-autocomplete>
                @if (form.value['company_product_phase_id'] !== '') {
                  <button matSuffix mat-icon-button aria-label="Clear" (click)="resetCompanyProductPhase()">
                    <mat-icon>close</mat-icon>
                  </button>
                }
              </mat-form-field>
            </div>
          </div>
        }
      </div>

      <div class="col-12 col-lg-7">
        <mat-label>Descripción</mat-label>
        <mat-form-field appearance="outline" style="width: 100%" class="nobottom">
          <textarea matInput formControlName="description" rows="14"></textarea>
        </mat-form-field>
      </div>
    </div>
  </div>
</mat-dialog-content>

@if (is_location_required_and_missing()) {
  <div class="location-warning">
    <mat-icon>location_off</mat-icon>
    <div class="location-warning__content">
      <p>
        Tienes un viaje programado para esta fecha. Para registrar tiempo necesitamos acceso a tu ubicación GPS. Habilita los permisos de
        ubicación en tu dispositivo y haz click
        <button type="button" class="location-warning__link" (click)="retryLocation()">aquí</button>
        para reintentar obtener tu ubicación.
      </p>
    </div>
  </div>
}

<mat-dialog-actions align="end" class="d-flex gap-2">
  <app-location-selector
    #locationSelector
    [relatable_type]="LocationRelatableTypeEnum.User"
    [relatable_id]="form.value.user_id"
    (location_change)="onLocationChange($event)"
    (icloud_private_relay_warning)="onIcloudPrivateRelayWarningChange($event)"
  />

  <span class="save-button-wrapper" [matTooltip]="save_button_tooltip()" [matTooltipDisabled]="!is_location_required_and_missing()">
    <button mat-flat-button color="accent" (click)="save()" [disabled]="!can_submit()" type="submit">
      <mat-icon style="margin-right: 10px">{{ data.is_editing ? 'save' : 'add' }}</mat-icon>
      {{ data.is_editing ? 'Guardar cambios' : 'Registrar tiempo' }}
    </button>
  </span>
</mat-dialog-actions>
